export const BANNER_DDJJ = {
  texto:
    'Para acceder a la información médica, cargá la Declaración Jurada. Provincia ART la verificará y, una vez aprobada, podrás consultar la información.',
  link: 'Cargar Declaración Jurada',
}
